import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'shards-react';
import { useSiblingPayments } from '../../../hooks/queries/useSiblingPayments';

const SiblingsPayments = ({ paymentId }) => {
  const { siblingsPayments, error } = useSiblingPayments(paymentId);

  if (error) return <Alert theme="danger">No se pudieron cargar las liquidaciones hermanas.</Alert>;

  return (
    <ul>
      {!siblingsPayments.length ? (
        <span>No se encontraron liquidaciones hermanas</span>
      ) : (
        siblingsPayments.map((sibling) => (
          <li key={sibling.id}>
            <a href={`/admin/payments/${sibling.id}`}>{sibling.id}</a>
          </li>
        ))
      )}
    </ul>
  );
};

SiblingsPayments.propTypes = {
  paymentId: PropTypes.string.isRequired
};

export default SiblingsPayments;
